export interface ProcessStep {
  step: string;
  title: string;
  icon: string;
  description: string;
}

export const processSteps: ProcessStep[] = [
  {
    step: "01",
    title: "Vehicle Assessment",
    icon: "ri-search-eye-line",
    description:
      "We begin with the existing vehicle — its condition, architecture, weight and current usage — because the retrofit starts from what is already there.",
  },
  {
    step: "02",
    title: "Technical Feasibility",
    icon: "ri-file-list-3-line",
    description:
      "A feasibility review determines whether a retrofit is technically suitable. Not every vehicle is a candidate; final feasibility is subject to assessment.",
  },
  {
    step: "03",
    title: "Retrofit Engineering",
    icon: "ri-ruler-2-line",
    description:
      "The retrofit is engineered around the specific vehicle, covering mounting, integration and the electrical architecture.",
  },
  {
    step: "04",
    title: "Electric Powertrain Installation",
    icon: "ri-tools-line",
    description:
      "The internal combustion drive is replaced with an electric powertrain configuration matched to the vehicle and application.",
  },
  {
    step: "05",
    title: "Battery & Control Systems",
    icon: "ri-battery-charge-line",
    description:
      "The battery system, BMS and control systems are integrated and configured so the vehicle operates as a connected electric vehicle.",
  },
  {
    step: "06",
    title: "Testing & Deployment",
    icon: "ri-checkbox-circle-line",
    description:
      "Testing, checks and deployment follow. Final configuration is confirmed only after technical assessment.",
  },
];